import { useCallback, useState, useMemo } from 'react';
import debounceHook from '../../debounceHook';
import { Colors } from '../../../../themes/colors';

export const OfficeSearch = ({ officeList = [], onSelectOffice }) => {
  const [searchText, setSearchText] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const debouncedSearchText = debounceHook(searchText, 300);

  // Filter offices based on debounced search text
  const filteredOffices = useMemo(() => {
    if (!debouncedSearchText.trim()) {
      return officeList;
    }

    const searchLower = debouncedSearchText.toLowerCase();
    return officeList.filter((office) => office.officeName?.toLowerCase().includes(searchLower));
  }, [officeList, debouncedSearchText]);

  const handleSelectOffice = useCallback(
    (office) => {
      if (onSelectOffice) {
        onSelectOffice(office);
      }
      setSearchText('');
      setIsFocused(false);
    },
    [onSelectOffice],
  );

  const renderOfficesList = useCallback(() => {
    // Only show list when input is focused
    if (!isFocused) return null;

    return (
      <div
        className="card"
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          marginTop: 45,
          background: '#ffffff',
          position: 'absolute',
          zIndex: 5,
          maxHeight: 300,
          overflowY: 'auto',
        }}
      >
        {filteredOffices?.length ? (
          filteredOffices.slice(0, 10).map((office) => (
            <button
              key={office.id}
              type="button"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: 'none',
                borderBottom: '1px solid #e0e0e0',
                background: '#ffffff',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'background-color 0.2s',
              }}
              onClick={() => handleSelectOffice(office)}
              onMouseDown={(e) => {
                // Prevent input blur when clicking on button
                e.preventDefault();
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f5f5f5';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    color: Colors.secondary_500,
                  }}
                >
                  {office.officeName}
                </div>
                {office?.address?.length && office.address[0].formattedAddress ? (
                  <div className="f-dark">{office.address[0].formattedAddress}</div>
                ) : (
                  <div className="f-dark">No address</div>
                )}
              </div>
            </button>
          ))
        ) : (
          <div className="f-dark" style={{ textAlign: 'center' }}>
            No offices found
          </div>
        )}
      </div>
    );
  }, [isFocused, filteredOffices, handleSelectOffice]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <input
        type="text"
        placeholder="Type an Dentist Name"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          // Delay to allow click on office item
          setTimeout(() => setIsFocused(false), 200);
        }}
        className="form-control"
        style={{
          width: '100%',
          height: 45,
          fontSize: 14,
          fontFamily: 'Nunito',
        }}
      />

      {renderOfficesList()}
    </div>
  );
};
